import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TransactionAccessService } from '../shared/services/transaction-access.service';

export const transactionAccessGuard: CanActivateFn = (_route, state) => {
  const accessService = inject(TransactionAccessService);
  const router = inject(Router);

  return accessService.hasRouteAccess(state.url)
    ? true
    : router.createUrlTree(['/acceso-denegado'], {
        queryParams: { ruta: state.url.split('?')[0] }
      });
};
